<template>
  <div>
    <div class="ts_banner"></div>
    <el-tabs v-model="activeName" @tab-click="handleClick" stretch>
      <el-tab-pane label="关于我们" name="first">
        <div class="pull_box">
          <div class="inner_active_box">
            <div class="inner_this_title">
              <div class="inner_this_title_in">
                <span>
                  <img src="@/assets/images/logo@2x.png" alt="" />
                </span>
                <span>关于白玉兰</span>
              </div>
            </div>
            <div class="inner_this_box clearfix">
              <div class="inner_this_left fl">
                <div class="inner_box scrollbarWrapper">
                  <div class="viewport inner_box_this">
                    <div class="inner_this_top">
                      <p>
                        新白玉兰在线平台以上海白玉兰远程教育网作为基础的移动在线教育培训平台，以云计算、大数据分析为后台，为各职业教育机构、大专院校、企事业单位提供开放式的培训平台，软件功能定制服务，移动微课堂，个人学习管理、学员教师交流社区，教学课件资源共享，课程老师评价等全新的培训体验，集在线考试、组织管理、数据管理、消息管理为一体。平台共经过3次改版，2000年12月白玉兰远程网正式开通，2012年3月白玉兰远程教育网“天地合一”，2017年1月白玉兰远程教育平台新版上线，2018年11月，新白玉兰在线平台同步在PC端和手机端上线。
                      </p>
                      <p>新白玉兰在线平台有三大业务应用场景设计方向：</p>
                      <p>
                        1、职称教育：职业培训教育，大型职业培训考试网站,开设公务员,经济师,职称英语,职称计算机,招标师,人力资源管理师,心理咨询师,注册消防工程师等国家职业资格考试网上辅导培训。
                      </p>
                      <p>
                        2、企业内训：解决企业当前问题,提升人员胜任能力,通过团队行动学习,使培训成效显著提升,效果实现可视化,解决企业的实际问题。
                      </p>
                      <p>
                        3、安全培训：指企业员工在生产过程中或生产过程中的设备没有危险、不受威胁、不出事故。比如生产过程中的人身和设备安全、道路交通中的人身和车辆安全等等。
                      </p>
                      <p>
                        新白玉兰在线平台现有八大特色技术服务，即“专业化部署、深度化定制、多维度数据、全流程培训、针对性考试、互动性社区、高匹配课程、激励性积分”。十二大功能模块：“培训计划管理、课程管理、考试管理、直播管理、问卷调查管理、机构信息管理、组织架构管理、用户管理、报名管理、讲师管理、证书管理、内容管理”每个功能模块都可以依据不同场景进行不同分配。同时也紧跟国家政策引领，聚焦信息网络、平台体系、数字化资源、智慧校区等方面，积极推进云计算、大数据、物联网、虚拟仿真、人工智能等技术创新应用，从而推动教育理念更新、模式变革、体系重构。
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="inner_this_right fl">
                <div class="video-top">
                  <div class="recommend_video" @click="palyVideo">
                    <img
                      class="play"
                      src="@/assets/images/icon_play.png"
                      alt="白玉兰"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </el-tab-pane>
    </el-tabs>
    <el-dialog :visible.sync="dialogVisible" >
     <!-- <video src="@/assets/video/aboutUs.mp4"></video> -->
     <video controls autoplay loop="true" v-if="dialogVisible" style="width: 100%;">
       <source src="@/assets/video/aboutUs.mp4" type="video/mp4">
     </video>

    </el-dialog>
  </div>
</template>

<script>

export default {
  data() {
    return {
      activeName: "first",
      dialogVisible:false,
    };
  },
  methods: {
    handleClick(tab, event) {
      console.log(tab, event);
    },
    palyVideo() {
      this.dialogVisible = true
    },
  },
};
</script>

<style lang="scss">
::v-deep .el-tabs__nav-scroll {
  width: 50% !important;
  margin: 0 auto !important;
}
.pull_box {
  // position: absolute;
  left: 0px;
  top: 0px;
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  .inner_active_box {
    width: 1170px;
    margin: 0 auto;
    .inner_this_title {
      font-size: 28px;
      font-weight: 500;
      line-height: 24px;
      color: #333333;
      text-align: left;
      width: 100%;
      margin-bottom: 15px;
      padding-top: 15px;
      overflow: hidden;
      .inner_this_title_in {
        float: left;
        width: 674px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        // img {
        //   max-height: 39px;
        // }
      }
    }
  }
  .inner_this_box {
    width: 100%;
    .inner_this_left {
      width: 674px;
      .inner_box {
        width: 100% !important;
        margin: 0px !important;
        .inner_box_this {
          width: 100%;
          height: 170px !important;
          background: #ffffff !important;
          .inner_this_top {
            width: 100%;
            height: 100%;
            overflow-y: auto;
            padding: 0 8px 8px 0;
            box-sizing: border-box;
            p {
              line-height: 24px;
              text-indent: 2em;
              color: #666666;
              font-size: 14px;
              text-align: justify;
              text-justify: distribute;
            }
            p:not(:last-child) {
              margin-bottom: 8px;
            }
          }
        }
      }
      .scrollbarWrapper {
        width: 80%;
        margin: 20px auto 10px;
        position: relative;
        .viewport {
          height: 270px !important;
          overflow: hidden;
          position: relative;
          background: #dedede;
        }
      }
    }
    .inner_this_right {
      width: 437px;
      margin-left: 59px;
      box-sizing: border-box;
      position: relative;
      .video-top {
        display: flex;
        margin-bottom: 96px;
        .recommend_video {
          width: 100%;
          margin-right: 0px;
          height: 245px;
          background-image: url("http://inesa-test.oss-cn-shanghai.aliyuncs.com/byl/1553137058972352414.jpg");
          cursor: pointer;
          position: relative;
          background-repeat: no-repeat;
          background-size: cover;
          background-position: center;
          .play {
            position: absolute;
            left: 50%;
            top: 50%;
            transform: translateX(-50%) translateY(-50%);
          }
        }
      }
    }
  }
}
.fl {
  float: left;
}
.clearfix:before,
.clearfix:after {
  /*æ¸…æ¥šæµ®åŠ¨*/
  content: "";
  display: table;
}

.clearfix:after {
  clear: both;
}

.clearfix {
  *zoom: 1;
  /*IE/7/6*/
}
</style>


// WEBPACK FOOTER //
// src/page/byl/aboutUs/aboutUs.vue